import { z } from "zod";

import { cvpRangeMachineSchema } from "./cvp-range";
import { emMachineSchema } from "./em";
import { everestMachineSchema } from "./everest";
import { fusionMachineSchema } from "./fusion";
import { impackMachineSchema } from "./impack";
import { lantechMachineSchema } from "./lantech";
import { pl1MachineSchema } from "./pl1";
import { sealProXMachineSchema } from "./seal-pro-x";
import { x4MachineSchema } from "./x4";
import { x5MachineSchema } from "./x5";
import { x6MachineSchema } from "./x6";
import { x7MachineSchema } from "./x7";
import { zebraMachineSchema } from "./zebra";

export const machineSchema = z.union([
	cvpRangeMachineSchema,
	emMachineSchema,
	everestMachineSchema,
	fusionMachineSchema,
	impackMachineSchema,
	lantechMachineSchema,
	pl1MachineSchema,
	sealProXMachineSchema,
	x4MachineSchema,
	x5MachineSchema,
	x6MachineSchema,
	x7MachineSchema,
	zebraMachineSchema,
]);

export type Machine = z.infer<typeof machineSchema>;
